/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_InstructionsInputs */

const vi_pesticide_instructions = /** @type {(inputs: Pesticide_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng dẫn sử dụng`)
};

/**

* @param {Pesticide_InstructionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_instructions = /** @type {((inputs?: Pesticide_InstructionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_InstructionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_instructions(inputs)
});